/* eslint-disable no-unused-expressions */
import { toast } from 'react-hot-toast';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { frontAppFailure, getAllFrontappSucess, getFrontappCompletedSuccess, updateBulkDTPMSuccess, updateCommentSuccess, updateDTPMSuccess, updateFolderSuccess, updateProjectNameSuccess, startFrontAppTimerSuccess, pauseFrontAppTimerSuccess, resumeFrontAppTimerSuccess, getFrontAppTimerStatusSuccess, getCaPhaseTasksSuccess, getCaPhaseTasksFailure, updateCaPhaseTasksSuccess, updateCaPhaseTasksFailure, getRunningFrontAppTaskSuccess, getRunningFrontAppTaskFailure } from '../actions/frontApp.Action';
import { loginUserFailure } from '../actions/login.action';
import { GetAllFrontAppApi, getAllFrontAppCompletedItemsApi, updateBulkDTPMApi, updateCommentApi, updateDTPM, updateFolderApi, updateProjectNameApi, startFrontAppTimerApi, pauseFrontAppTimerApi, resumeFrontAppTimerApi, getFrontAppTimerStatusApi, getCaPhaseTasksApi, updateCaPhaseTasksApi, getRunningFrontAppTaskApi } from '../api';
import { FRONT_APP, FRONT_APP_COMPLETED_ITEMS, UPDATE_COMMENT, UPDATE_DT_PM, UPDATE_BULK_DT_PM, UPDATE_FOLDER_NUMBER, UPDATE_PROJECT_NAME, START_FRONTAPP_TIMER, PAUSE_FRONTAPP_TIMER, RESUME_FRONTAPP_TIMER, GET_FRONTAPP_TIMER_STATUS, GET_CA_PHASE_TASKS, UPDATE_CA_PHASE_TASKS, GET_RUNNING_FRONTAPP_TASK } from '../storeTypes';

function* refetchFrontAppLists(isSilent = false) {
    const apiEndPoint = yield select((state) => state.frontApp?.apiEndPoint);
    const apiEndPointCompleted = yield select((state) => state.frontApp?.apiEndPointCompleted);
    if (apiEndPoint) {
        yield put({ type: FRONT_APP, payload: apiEndPoint, isSilent });
    }
    if (apiEndPointCompleted) {
        yield put({ type: FRONT_APP_COMPLETED_ITEMS, payload: apiEndPointCompleted, isSilent });
    }
}

function* getAllFrontappSaga(action) {
    try {
        const response = yield call(GetAllFrontAppApi, action?.payload);
        if (response.data.data) {
            yield put(getAllFrontappSucess(response.data));

        }
    } catch (error) {
        if (error?.response?.status === 403) {
            console.error('Token not provided or expired');
        } else {
            yield put(loginUserFailure(error));
        }
    }
}
function* getAllFrontappCompletedSaga(action) {
    try {
        const response = yield call(getAllFrontAppCompletedItemsApi, action?.payload);
        if (response.data.data) {
            yield put(getFrontappCompletedSuccess(response.data));

        }
    } catch (error) {
        if (error?.response?.status === 403) {
            console.error('Token not provided or expired');
        } else {
            yield put(loginUserFailure(error));
        }
    }
}
function* updateDTPMSaga(action) {
    try {
        const response = yield call(updateDTPM, action);
        if (response?.data?.data) {
            const updatedFields = { ...action?.payload };
            if (updatedFields.DT === "Completed") {
                updatedFields.DTUpdatedAt = new Date().toISOString();
            }
            yield put(updateDTPMSuccess({ ...response?.data, data: { ...response?.data?.data, ...updatedFields } }, action.id))
            toast.success(`${Object.keys(action?.payload)[0]} updated!`, { position: "top-center" });

            // Recall API ONLY for PM updates to ensure they move to completed tab
            if ("PM" in action.payload) {
                yield call(refetchFrontAppLists);
            } else if ("DT" in action.payload) {
                yield call(refetchFrontAppLists);
            }
        }
    } catch (error) {
        yield put(frontAppFailure(error));
    }
}
function* updateBulkDTPMSaga(action) {
    try {
        const { payload, callback } = action;
        const response = yield call(updateBulkDTPMApi, payload);

        if (response?.data?.data) {
            const dtUpdatedAt = payload?.DT === "Completed" ? new Date().toISOString() : undefined;
            const itemUpdates = payload.comment_ids.map(id => ({
                comment_id: id,
                ...payload,
                ...(dtUpdatedAt ? { DTUpdatedAt: dtUpdatedAt } : {})
            }));
            yield put(updateBulkDTPMSuccess(itemUpdates));
            toast.success(`Successfully updated ${payload.comment_ids?.length || 0} items!`, { position: "top-center" });
            yield call(refetchFrontAppLists);

            if (callback && typeof callback === 'function') {
                callback();
            }
        }
    } catch (error) {
        toast.error(`Error updating items.`, { position: "top-center" });
        console.error(error);
        yield put(frontAppFailure(error));
    }
}
function* updateCommentSaga(action) {

    try {
        const response = yield call(updateCommentApi, action);
        if (response?.data?.data) {
            yield put(updateCommentSuccess({ ...response?.data, data: { ...response?.data?.data, ...action?.payload } }, action.id))
            toast.success("Comment updated!", { position: "bottom-center" });
        }
    } catch (error) {
        yield put(frontAppFailure(error));
    }
}
function* updateFolderSaga(action) {

    try {
        const response = yield call(updateFolderApi, action);
        if (response?.data?.data) {
            yield put(updateFolderSuccess(response?.data))
            toast.success("Folder number updated!");
            yield call(refetchFrontAppLists);
        }
    } catch (error) {
        yield put(frontAppFailure(error));
    }
}
function* updateProjectNameSaga(action) {
    try {
        const response = yield call(updateProjectNameApi, action);
        if (response?.data?.data) {
            yield put(updateProjectNameSuccess({ ...response?.data, data: { ...response?.data?.data, ...action?.payload } }, action.id));
            const message = "manager" in action?.payload
                ? "Task Manager updated successfully!"
                : "Project updated successfully!";
            toast.success(message);
            // Silently refetch all data so the updated manager info reflects correctly
            yield call(refetchFrontAppLists, true);
        }
    } catch (error) {
        console.error("Error updating project name:", error);
        yield put(frontAppFailure(error));
    }
}

function* startFrontAppTimerSaga(action) {
    try {
        const response = yield call(startFrontAppTimerApi, action.id);
        if (response?.data) {
            yield put(startFrontAppTimerSuccess(response.data));
            toast.success("Timer started successfully!");
            yield call(refetchFrontAppLists, true);
            yield put({ type: GET_RUNNING_FRONTAPP_TASK });
        }
    } catch (error) {
        yield put(frontAppFailure(error));
    } finally {
        if (action.callback) action.callback();
    }
}

function* pauseFrontAppTimerSaga(action) {
    try {
        const response = yield call(pauseFrontAppTimerApi, action.id);
        if (response?.data) {
            yield put(pauseFrontAppTimerSuccess(response.data));
            toast.success("Timer paused successfully!");
            if (!action.skipRefetch) {
                yield call(refetchFrontAppLists, true);
            }
            yield put({ type: GET_RUNNING_FRONTAPP_TASK });
        }
    } catch (error) {
        yield put(frontAppFailure(error));
    } finally {
        if (action.callback) action.callback();
    }
}

function* resumeFrontAppTimerSaga(action) {
    try {
        const response = yield call(resumeFrontAppTimerApi, action.id);
        if (response?.data) {
            yield put(resumeFrontAppTimerSuccess(response.data));
            toast.success("Timer resumed successfully!");
            yield call(refetchFrontAppLists, true);
            yield put({ type: GET_RUNNING_FRONTAPP_TASK });
        }
    } catch (error) {
        yield put(frontAppFailure(error));
    } finally {
        if (action.callback) action.callback();
    }
}

function* getFrontAppTimerStatusSaga(action) {
    try {
        const response = yield call(getFrontAppTimerStatusApi, action.id);
        if (response?.data) yield put(getFrontAppTimerStatusSuccess(response.data));
    } catch (error) {
        yield put(frontAppFailure(error));
    }
}

function* getCaPhaseTasksSaga(action) {
    try {
        const response = yield call(getCaPhaseTasksApi, action.id, action.page, action.limit);
        if (response?.data) {
            yield put(getCaPhaseTasksSuccess({ data: response.data, page: action.page }));
            if (action.callback) action.callback(true);
        }
    } catch (error) {
        yield put(getCaPhaseTasksFailure(error));
        if (action.callback) action.callback(false);
    }
}

function* updateCaPhaseTasksSaga(action) {
    try {
        const response = yield call(updateCaPhaseTasksApi, action.projectId, action.id, action.payload);
        if (response?.data) {
            yield put(updateCaPhaseTasksSuccess({ ...response.data, requestPayload: action.payload }));
            toast.success("Task updated successfully!");
            if (action.callback) action.callback(true);
        }
    } catch (error) {
        yield put(updateCaPhaseTasksFailure(error));
        toast.error("Failed to update task.");
        if (action.callback) action.callback(false);
    }
}

function* getRunningFrontAppTaskSaga(action) {
    try {
        const response = yield call(getRunningFrontAppTaskApi);
        if (response?.data) {
            yield put(getRunningFrontAppTaskSuccess(response.data.data));
        }
    } catch (error) {
        yield put(getRunningFrontAppTaskFailure(error));
        yield put(getRunningFrontAppTaskSuccess(null));
    } finally {
        if (action.callback) action.callback();
    }
}

export function* FrontAppSaga() {
    [
        yield takeLatest(FRONT_APP, getAllFrontappSaga),
        yield takeLatest(FRONT_APP_COMPLETED_ITEMS, getAllFrontappCompletedSaga),
        yield takeLatest(UPDATE_DT_PM, updateDTPMSaga),
        yield takeLatest(UPDATE_BULK_DT_PM, updateBulkDTPMSaga),
        yield takeLatest(UPDATE_COMMENT, updateCommentSaga),
        yield takeLatest(UPDATE_FOLDER_NUMBER, updateFolderSaga),
        yield takeLatest(UPDATE_PROJECT_NAME, updateProjectNameSaga),
        yield takeLatest(START_FRONTAPP_TIMER, startFrontAppTimerSaga),
        yield takeLatest(PAUSE_FRONTAPP_TIMER, pauseFrontAppTimerSaga),
        yield takeLatest(RESUME_FRONTAPP_TIMER, resumeFrontAppTimerSaga),
        yield takeLatest(GET_FRONTAPP_TIMER_STATUS, getFrontAppTimerStatusSaga),
        yield takeLatest(GET_CA_PHASE_TASKS, getCaPhaseTasksSaga),
        yield takeLatest(UPDATE_CA_PHASE_TASKS, updateCaPhaseTasksSaga),
        yield takeLatest(GET_RUNNING_FRONTAPP_TASK, getRunningFrontAppTaskSaga)
    ];
}
